import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";

import { merge } from "lodash";

import { useAppDispatch } from "app/hooks";
import { setOnChange } from "components/confirm-dialog/confirm-dialog.slice";
import RadioGroupFormField from "components/radio-group-form-field";
import { hidePreview } from "features/scheduling/scheduler-slice";

import {
  CURRENT_EVENT,
  getRecurringEventOptions
} from "./edit-recurring-event-confirmation.util";

export type ConfirmationDialogValues = {
  option: string;
};

const DEFAULT_VALUES: ConfirmationDialogValues = {
  option: CURRENT_EVENT
};

type EditRecurringEventDialogContentProps = {
  eventType: string;
  eventEndTime?: string;
  changeCallback: (editRecurringEventType: string) => void;
};

export default function EditRecurringEventDialogContent({
  eventType,
  eventEndTime,
  changeCallback
}: EditRecurringEventDialogContentProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(hidePreview());
  }, [dispatch]);

  const defaultValues = useMemo(() => {
    return merge({}, DEFAULT_VALUES);
  }, []);

  const formMethods = useForm<ConfirmationDialogValues>({
    mode: "onChange",
    defaultValues
  });
  const { control, reset, watch } = formMethods;

  const option = watch("option");

  useEffect(() => {
    reset(merge(defaultValues));
  }, [defaultValues, reset]);

  const OPTIONS = useMemo(
    () => getRecurringEventOptions(eventType, new Date(eventEndTime)),
    [eventType, eventEndTime]
  );

  useEffect(() => {
    dispatch(
      setOnChange(() => {
        changeCallback(option);
      })
    );
  }, [changeCallback, dispatch, option]);

  return (
    <Box
      sx={{
        pr: 2,
        display: "flex",
        justifyContent: "flex-end"
      }}
    >
      <RadioGroupFormField
        name="option"
        label=""
        options={OPTIONS}
        control={control}
        required
        optionSx={{
          fontSize: "18px"
        }}
      />
    </Box>
  );
}
